import { Typography } from '@mui/material';

export default function AccessDenied() {
  return <Typography variant="h5">Access Denied</Typography>;
}
